export default {
    background: "https://assets.swoogo.com/uploads/full/2938167-6511a67435ac7.png",
    links: [
        {
            label: "Huawei",
            href: "/exhibition-hall-platinum",
            width: "16%",
            height: "25.7%",
            left: "23.2%",
            top: "4.4%",
        },
        {
            label: "KPMG",
            href: "/exhibition-hall-diamond",
            width: "18.8%",
            height: "28.5%",
            left: "41%",
            top: "2.1%",
        },
        {
            label: "IBM",
            href: "/exhibition-hall-platinum",
            width: "16.3%",
            height: "26.2%",
            left: "61%",
            top: "4.1%",
        },
        {
            label: "SecurityScorecard",
            href: "/exhibition-hall-gold",
            width: "14.4%",
            height: "24%",
            left: "20.4%",
            top: "30.8%",
        },
        {
            label: "SureCloud",
            href: "/exhibition-hall-gold",
            width: "14.8%",
            height: "24%",
            left: "35%",
            top: "30.8%",
        },
        {
            label: "CrowdStrike",
            href: "/exhibition-hall-gold",
            width: "14.8%",
            height: "24%",
            left: "50.5%",
            top: "30.8%",
        },
        {
            label: "BlueVoyant",
            href: "/exhibition-hall-gold",
            width: "14.8%",
            height: "24%",
            left: "66%",
            top: "30.8%",
        },
        {
            label: "ReversingLabs",
            href: "/exhibition-hall-silver-bronze",
            width: "14.2%",
            height: "20.5%",
            left: "82.8%",
            top: "25.5%",
        },
        {
            label: "Cofense",
            href: "/exhibition-hall-silver-bronze",
            width: "14.2%",
            height: "20.5%",
            left: "82.8%",
            top: "47.5%",
        },
        {
            label: "noetic",
            href: "/exhibition-hall-silver-bronze",
            width: "14.2%",
            height: "20.5%",
            left: "3.8%",
            top: "25.5%",
        },
        {
            label: "cybervadis",
            href: "/exhibition-hall-silver-bronze",
            width: "14.2%",
            height: "20.5%",
            left: "3.8%",
            top: "47.5%",
        },
        {
            label: "Atrium",
            href: "/atrium",
            width: "9.2%",
            height: "15.5%",
            left: "45.8%",
            top: "82.5%",
        },
    ],
    name: "exhibition-hall",
}